import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppState } from '../../../Configs/Redux/AppState';

export type RegisterInfoVisibleState = {
  registerInfoVisible: boolean;
  newUserId: number | null;
};

export const registerInfoVisibleInitialState = {
  registerInfoVisible: false,
  newUserId: null,
} as RegisterInfoVisibleState;

const registerInfoVisibleSlice = createSlice({
  name: 'registerInfoVisible',
  initialState: registerInfoVisibleInitialState,
  reducers: {
    showInfo(state, action: PayloadAction<number>) {
      state.registerInfoVisible = true;
      state.newUserId = action.payload;
    },
    hideInfo(state) {
      state.registerInfoVisible = false;
      state.newUserId = null;
    },
  },
});

export const { showInfo, hideInfo } = registerInfoVisibleSlice.actions;
export const registerInfoReducer = registerInfoVisibleSlice.reducer;

export const getInfoVisibleState = (state: AppState): boolean =>
  state.RegisterInfo.registerInfoVisible;

export const getNewUserIdState = (state: AppState): number | null =>
  state.RegisterInfo.newUserId;
